import React from "react";
import Jumbo from "../components/Jumbo";
import { Container, Row, Col } from "react-bootstrap";
import imageCurigma from "../assets/img/Image-curigma1.svg";

const pageName = "About us";
const message = "Igniting business with futuristic technology";

const AboutUsPage = () => {
  return (
    <div>
      <Jumbo pageName={pageName} message={message}></Jumbo>
      <Container className="main-section">
        <Row>
          <Col xs={12} sm={8}>
            <h1>Our story</h1>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={6}>
            <p>
              Thriving to ignite curiosity, Curigma has always taken a step
              forward to innovate technology in business. Super-talented minds
              with curiosity have always driven Curigma to deliver work that is
              not replaceable. All we do is ignite the technology factor in your
              business to help you keep running in the long run. Curigma started
              its journey with three minds that were curious to fuse technology
              into business.And that’s how it started in a small room. Curigma
              takes all the pride to work with the frontliners of the business
              world.
            </p>
          </Col>
          <Col xs={12} sm={6}>
            <p>
              And have never looked back. Located in Bhubaneswar, Odisha,
              Curigma operates throughout the globe. We work tirelessly to make
              sure your requirements meet your expectation. Curigma has always
              believed in customer satisfaction. And that keeps us moving to
              achieve our goal to automate businesses with advanced
              technologies. We design and develop to deliver perfection.
            </p>
          </Col>
        </Row>
        <hr></hr>
      </Container>
      <Container className="main-section">
        <Row>
          <Col xs={12} sm={6}>
            <h1>Natural ethics</h1>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={4}>
            <img src={imageCurigma} alt="product" />
          </Col>
          <Col xs={12} sm={8}>
            <p>
              Delivering perfection for years, Curigma believes in its own
              ethics. We have always made sure to bring uniqueness to all the
              products that we deliver. So, thinking out of the box, we have
              always delivered creativity in work. All the services that we
              deliver have no match in creativity and uniqueness. Further, we
              know the value of time for business. So, we commit the highest
              standard of professionalism when it comes to time. We efficiently
              manage our time to deliver work at your deadlines. And that’s not
              all! We try to bring as much transparency into the business as to
              make it satisfying for you.
            </p>
          </Col>
        </Row>
        <hr></hr>
      </Container>
    </div>
  );
};

export default AboutUsPage;
